module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "id": "lpn_1"
    }
  })]), _c('a', {
    attrs: {
      "id": "lpn_1"
    }
  }, [_c('p', {
    staticClass: "acknow"
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "bigspace"
  }), _c('p', {
    staticClass: "acknow_noind"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THIS BOOK")]), _vm._v(" would not have happened but for another that I published under the title "), _c('i', [_vm._v("Beauty for Truth’s Sake")]), _vm._v(" (Brazos, 2009). That was a study of the classical ‘Quadrivium’—the four mathematical or cosmological arts that once formed an essential part of a liberal education, preparing the student for the study of philosophy and theology. My book started with an interest in the symbolic and aesthetic qualities of numbers and shapes (I hasten to add unaccompanied by any expertise in mathematics or geometry), and became a kind of plea or even a manifesto for the reintegration in education of the arts and sciences. It was well received, and I was approached to write a sequel that would deal with the three preparatory arts, the ‘Trivium’ or liberal arts of language. That project turned into the present book, which might have been subtitled ‘Why the Trivium is Far from Trivial.’ Together the two books are intended to draw inspiration from the seven liberal arts for the purpose of rethinking the foundations of Catholic education in our own time. They are, I should stress, a work in progress.")]), _vm._v(" "), _c('p', {
    staticClass: "acknow_ind"
  }, [_vm._v("I must therefore particularly thank Fr Dominic O’Connor and his brother Greg O’Connor for commissioning this book as part of their broader UK-based project intended to produce resources for education and the ‘new evangelization.’ Without them it would simply not have been written. I want to thank also my new publishers, John Riess and James Wetmore, whose enthusiasm and encouragement at just the right time meant and continues to mean a great deal to me. Many others have given useful feedback on the book at different stages, including Jim Maroosis, Matthew Milliner, Fr Dominic O’Connor, Roy Peachey, Margaret Atkins, and Carol Bowling—and of course those who read the book for the publisher, including Fr Aidan Nichols OP, Fr James V. Schall SJ, and Dr Cyrus P. Olsen III, and especially the author of the Foreword, Anthony Esolen.")])]), _c('p', {
    staticClass: "acknow_ind"
  }, [_c('a', {
    attrs: {
      "id": "lpn_1"
    }
  }), _c('a', {
    attrs: {
      "id": "lpn_2"
    }
  }, [_vm._v("The reader is urged to refer to the author’s website for further discussion of the philosophy and reform of education at "), _c('i')]), _c('i', [_c('a', {
    attrs: {
      "href": "http://beauty-in-education.blogspot.com",
      "target": "_blank"
    }
  }, [_vm._v("http://beauty-in-education.blogspot.com")])]), _vm._v(", including practical aspects which have only been touched on in this volume. As mentioned, this book is part of a wider, ongoing project, and I am excited at the prospect of helping to develop over the next few years, if God permits and with the assistance of teachers and parents on both sides of the Atlantic, other books and supporting materials for homes, schools, and parishes.")]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "acknow_right"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("STRATFORD CALDECOTT")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9e52096","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/06_acknowledgments.vue
// module id = 72
// module chunks = 0